import React, { Fragment } from "react";
import { logoutUser } from "../../feature/auth/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Avatar, { genConfig } from "react-nice-avatar";
import {
  ProfileCard,
  ProfileContainer,
  ProfileLink,
  ProfileLinkContainer,
  ProfileList,
} from "./Profile.styled";

const PROFILE_LINKS = [
  // {
  //   name: "Account Settings",
  //   link: "/account-settings",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12Z"
  //         fill="#C597F8"
  //       />
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M15.4645 5.05026L12.4142 2L9.36397 5.05026H5.05025V9.36397L2 12.4142L5.05025 15.4644V19.7782H9.36397L12.4142 22.8284L15.4645 19.7782H19.7782V15.4645L22.8284 12.4142L19.7782 9.36396V5.05026H15.4645ZM10.1924 7.05026L12.4142 4.82843L14.636 7.05026H17.7782V10.1924L20 12.4142L17.7782 14.636V17.7782H14.636L12.4142 20L10.1924 17.7782H7.05025V14.636L4.82843 12.4142L7.05025 10.1924V7.05026H10.1924Z"
  //         fill="#C597F8"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   name: "Reward",
  //   link: "/reward",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="25"
  //       viewBox="0 0 24 25"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M7.48334 5.33456C6.33891 5.46331 5.42286 6.37258 5.29045 7.51224C4.93476 10.5737 4.93476 13.6664 5.29045 16.7278C5.42286 17.8675 6.33891 18.7767 7.48334 18.9055C10.4602 19.2404 13.5398 19.2404 16.5167 18.9055C17.6611 18.7767 18.5771 17.8675 18.7095 16.7278C18.9651 14.5281 19.0371 12.3122 18.9254 10.1034C18.9225 10.0464 18.9436 9.99072 18.9838 9.95034L20.0225 8.90463C20.1428 8.7836 20.3482 8.85928 20.361 9.02997C20.557 11.6522 20.5032 14.2888 20.1994 16.9032C19.9845 18.7524 18.5096 20.2006 16.6833 20.4062C13.5957 20.7535 10.4043 20.7535 7.31673 20.4062C5.49035 20.2006 4.01545 18.7524 3.80061 16.9032C3.43137 13.7252 3.43137 10.5148 3.80061 7.33683C4.01545 5.48762 5.49035 4.03938 7.31673 3.8339C10.4043 3.48652 13.5957 3.48652 16.6833 3.8339C17.3265 3.90627 17.9262 4.1328 18.4425 4.47672C18.5441 4.54438 18.5542 4.68818 18.4681 4.7749L17.6652 5.58313C17.5995 5.64924 17.4976 5.66037 17.4158 5.6162C17.1424 5.46874 16.8386 5.37077 16.5167 5.33456C13.5398 4.99963 10.4602 4.99963 7.48334 5.33456Z"
  //         fill="#C597F8"
  //       />
  //       <path
  //         d="M21.0303 6.11053C21.3232 5.81567 21.3232 5.33764 21.0303 5.04279C20.7374 4.74794 20.2626 4.74794 19.9697 5.04279L11.5 13.5689L9.03033 11.0828C8.73744 10.788 8.26256 10.788 7.96967 11.0828C7.67678 11.3777 7.67678 11.8556 7.96967 12.1505L10.9697 15.1705C11.2626 15.4653 11.7374 15.4653 12.0303 15.1705L21.0303 6.11053Z"
  //         fill="#C597F8"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   name: "Invite others",
  //   link: "/invite",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M20.9439 18.432C20.9342 18.7771 20.8552 19.1167 20.7118 19.4307C20.5683 19.7446 20.3632 20.0266 20.1086 20.2598C19.8541 20.4929 19.5553 20.6726 19.23 20.7881C18.9047 20.9036 18.5595 20.9525 18.2149 20.932C16.0619 20.944 13.9079 20.932 11.7549 20.932C11.6223 20.932 11.4951 20.8793 11.4013 20.7856C11.3076 20.6918 11.2549 20.5646 11.2549 20.432C11.2549 20.2994 11.3076 20.1722 11.4013 20.0785C11.4951 19.9847 11.6223 19.932 11.7549 19.932C13.9549 19.932 16.1549 19.964 18.3549 19.932C19.4619 19.916 19.9439 19.084 19.9439 18.094V5.63002C19.9515 5.31531 19.8627 5.00579 19.6896 4.7429C19.5164 4.48001 19.267 4.2763 18.9749 4.15902C18.6296 4.06489 18.2704 4.03272 17.9139 4.06402H11.7549C11.6223 4.06402 11.4951 4.01134 11.4013 3.91758C11.3076 3.82381 11.2549 3.69663 11.2549 3.56402C11.2549 3.43141 11.3076 3.30424 11.4013 3.21047C11.4951 3.1167 11.6223 3.06402 11.7549 3.06402C13.9799 3.06402 16.2199 2.97902 18.4429 3.06402C18.7832 3.07249 19.1184 3.1486 19.429 3.2879C19.7396 3.4272 20.0194 3.62691 20.2521 3.8754C20.4848 4.1239 20.6657 4.4162 20.7843 4.73529C20.9029 5.05439 20.9568 5.39389 20.9429 5.73402L20.9439 18.432Z"
  //         fill="#C597F8"
  //       />
  //       <path
  //         d="M15.7939 12.354C15.8783 12.2716 15.9277 12.1599 15.9319 12.042C15.9349 12.0282 15.9369 12.0141 15.9379 12C15.9369 11.9862 15.9349 11.9725 15.9319 11.959C15.9284 11.8407 15.8789 11.7284 15.7939 11.646L12.1249 7.978C12.0306 7.88692 11.9043 7.83653 11.7732 7.83767C11.6421 7.8388 11.5167 7.89139 11.424 7.98409C11.3313 8.0768 11.2787 8.2022 11.2776 8.3333C11.2765 8.4644 11.3269 8.5907 11.4179 8.685L14.2339 11.5H3.49194C3.35934 11.5 3.23216 11.5527 3.13839 11.6464C3.04462 11.7402 2.99194 11.8674 2.99194 12C2.99194 12.1326 3.04462 12.2598 3.13839 12.3536C3.23216 12.4473 3.35934 12.5 3.49194 12.5H14.2339L11.4179 15.315C11.3269 15.4093 11.2765 15.5356 11.2776 15.6667C11.2787 15.7978 11.3313 15.9232 11.424 16.0159C11.5167 16.1086 11.6421 16.1612 11.7732 16.1623C11.9043 16.1635 12.0306 16.1131 12.1249 16.022L15.7939 12.354Z"
  //         fill="#C597F8"
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Downlines",
    link: "/downlines",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.3999 11.8107C6.3999 12.616 6.5999 13.4213 6.8999 14.126H2.7999C2.1999 14.126 1.5999 13.824 1.2999 13.3207C0.999902 12.7167 0.899902 12.1127 1.0999 11.6093C1.4999 10.6026 2.2999 9.79729 3.1999 9.29396C2.7999 8.79062 2.4999 8.08596 2.4999 7.38129C2.4999 5.87129 3.7999 4.56262 5.2999 4.56262C6.8999 4.56262 8.0999 5.87129 8.0999 7.38129C8.0999 7.48196 8.0999 7.68329 8.0999 7.78396C7.0999 8.79062 6.3999 10.2 6.3999 11.8107Z"
          fill="#C597F8"
        />
        <path
          d="M22.6999 13.22C22.3999 13.7234 21.7999 14.0254 21.1999 14.0254H17.0999C17.3999 13.3207 17.5999 12.5154 17.5999 11.71C17.5999 10.0994 16.9999 8.69004 15.8999 7.68337C15.8999 7.5827 15.8999 7.38137 15.8999 7.2807C15.8999 5.67004 17.1999 4.46204 18.6999 4.46204C20.1999 4.46204 21.4999 5.7707 21.4999 7.2807C21.4999 7.98537 21.1999 8.69004 20.7999 9.19337C21.6999 9.79737 22.3999 10.6027 22.8999 11.6094C23.0999 12.1127 22.9999 12.7167 22.6999 13.22Z"
          fill="#C597F8"
        />
        <path
          d="M14.8744 13.9487C15.8744 13.244 16.5744 12.036 16.5744 10.6267C16.5744 8.4121 14.7744 6.6001 12.5744 6.6001C10.3744 6.6001 8.47443 8.51276 8.47443 10.7274C8.47443 12.036 9.17443 13.244 10.1744 14.0494C8.37443 14.6534 6.97443 16.0628 6.17443 17.8748C5.87443 18.5795 5.97443 19.3847 6.37443 20.0894C6.87443 20.794 7.57443 21.1967 8.37443 21.1967H16.5744C17.3744 21.1967 18.1744 20.794 18.5744 20.0894C18.9744 19.3847 19.0744 18.5795 18.7744 17.8748C18.0744 15.9621 16.5744 14.6534 14.8744 13.9487Z"
          fill="#C597F8"
        />
      </svg>
    ),
  },
  {
    name: "About Pubmining",
    link: "/about",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 10.3616C13.5 9.94465 13.1642 9.60663 12.75 9.60663H6.75C6.33579 9.60663 6 9.94465 6 10.3616C6 10.7786 6.33579 11.1166 6.75 11.1166H12.75C13.1642 11.1166 13.5 10.7786 13.5 10.3616Z"
          fill="#C597F8"
        />
        <path
          d="M12.5 13.3816C12.5 12.9647 12.1642 12.6266 11.75 12.6266H6.75C6.33579 12.6266 6 12.9647 6 13.3816C6 13.7986 6.33579 14.1366 6.75 14.1366H11.75C12.1642 14.1366 12.5 13.7986 12.5 13.3816Z"
          fill="#C597F8"
        />
        <path
          d="M12.75 15.6466C13.1642 15.6466 13.5 15.9846 13.5 16.4016C13.5 16.8186 13.1642 17.1566 12.75 17.1566H6.75C6.33579 17.1566 6 16.8186 6 16.4016C6 15.9846 6.33579 15.6466 6.75 15.6466H12.75Z"
          fill="#C597F8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 22.4416H19C20.5188 22.4416 21.75 21.2022 21.75 19.6733V14.1366C21.75 13.7197 21.4142 13.3816 21 13.3816H17.75V5.52278C17.75 4.08989 16.1411 3.2564 14.9828 4.08926L14.8078 4.21512C14.0273 4.77633 12.9701 4.77444 12.1859 4.2106C10.8821 3.27306 9.11794 3.27306 7.81407 4.2106C7.02992 4.77444 5.9727 4.77633 5.19221 4.21512L5.01717 4.08926C3.8589 3.2564 2.25 4.08989 2.25 5.52278V18.6666C2.25 20.7515 3.92893 22.4416 6 22.4416ZM8.68593 5.43934C9.46825 4.87681 10.5318 4.87681 11.3141 5.43934C12.6161 6.37557 14.3739 6.38272 15.6796 5.44386L15.8547 5.31799C16.0202 5.19902 16.25 5.31808 16.25 5.52278V19.6733C16.25 20.1264 16.3581 20.5541 16.5499 20.9316H6C4.75736 20.9316 3.75 19.9176 3.75 18.6666V5.52278C3.75 5.31808 3.97984 5.19902 4.14531 5.31799L4.32036 5.44386C5.62605 6.38272 7.3839 6.37556 8.68593 5.43934ZM17.75 19.6733V14.8916H20.25V19.6733C20.25 20.3683 19.6904 20.9316 19 20.9316C18.3096 20.9316 17.75 20.3683 17.75 19.6733Z"
          fill="#C597F8"
        />
      </svg>
    ),
  },
  {
    name: "Contact Support",
    link: "/contact-support",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.84022 10.7421C7.62754 14.6599 10.8081 17.7747 14.7618 19.4625L14.7743 19.4678L15.5381 19.8105C16.5108 20.2468 17.654 19.9369 18.2776 19.0681L19.552 17.2926C19.6298 17.1842 19.6097 17.0334 19.5063 16.9493L17.2816 15.1426C17.171 15.0528 17.0083 15.0737 16.9237 15.1886L16.0579 16.3648C15.8476 16.6505 15.4678 16.7497 15.1461 16.6032C12.1897 15.2562 9.81391 12.8647 8.47598 9.8886C8.33036 9.56468 8.42896 9.1824 8.71271 8.97072L9.88109 8.09908C9.99526 8.01391 10.0161 7.85021 9.92681 7.73887L8.13177 5.499C8.04834 5.39489 7.8986 5.37467 7.79087 5.45296L6.01757 6.74165C5.14878 7.37303 4.84283 8.53355 5.28629 9.5155L5.83963 10.7408L5.84022 10.7421ZM14.1699 20.85C9.87386 19.0142 6.41849 15.6288 4.47645 11.3708L4.47528 11.3683L3.92078 10.1404C3.18168 8.50385 3.6916 6.56963 5.13959 5.51735L6.91288 4.22865C7.667 3.68061 8.71523 3.82216 9.29922 4.55088L11.0943 6.79076C11.7189 7.57009 11.5734 8.71607 10.7742 9.31226L10.1047 9.81173C11.2357 12.0207 13.028 13.8251 15.2224 14.9635L15.7186 14.2895C16.3108 13.4851 17.4492 13.3386 18.2234 13.9674L20.4481 15.7741C21.1722 16.3622 21.3127 17.4178 20.7678 18.177L19.4934 19.9524C18.4541 21.4005 16.5487 21.9169 14.9277 21.1898L14.1699 20.85Z"
          fill="#C597F8"
        />
      </svg>
    ),
  },
  {
    name: "FAQ",
    link: "/faq",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 11.8638 14.7252 13.4299 13 13.874V14.5125H11V12H12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10H8Z"
          fill="#C597F8"
        />
        <path d="M13 18V16H11V18H13Z" fill="#C597F8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
          fill="#C597F8"
        />
      </svg>
    ),
  },
  {
    name: "Log Out",
    link: "",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 19C11.25 18.5858 11.5858 18.25 12 18.25H18C18.1381 18.25 18.25 18.1381 18.25 18V6C18.25 5.86193 18.1381 5.75 18 5.75H12C11.5858 5.75 11.25 5.41421 11.25 5C11.25 4.58579 11.5858 4.25 12 4.25H18C18.9665 4.25 19.75 5.0335 19.75 6V18C19.75 18.9665 18.9665 19.75 18 19.75H12C11.5858 19.75 11.25 19.4142 11.25 19Z"
          fill="#C597F8"
        />
        <path
          d="M15.6116 13.1152C15.6116 13.6675 15.1639 14.1152 14.6116 14.1152H9.75562C9.73269 14.4706 9.70399 14.8258 9.66951 15.1805L9.63985 15.4857C9.59162 15.982 9.06466 16.2791 8.61504 16.0637C6.78712 15.1876 5.13234 13.9889 3.73028 12.525L3.70032 12.4937C3.43323 12.2148 3.43323 11.7751 3.70032 11.4962L3.73028 11.4649C5.13234 10.001 6.78712 8.80227 8.61504 7.92626C9.06466 7.71078 9.59162 8.00797 9.63985 8.50421L9.66951 8.80941C9.70399 9.16414 9.73269 9.51929 9.75562 9.87471L14.6116 9.87472C15.1639 9.87472 15.6116 10.3224 15.6116 10.8747V13.1152Z"
          fill="#C597F8"
        />
      </svg>
    ),
  },
];

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const config = genConfig(`${Object.keys(user).length && user.username}`);

  return (
    <ProfileContainer>
      <ProfileCard>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBlock: "10px 0px",
          }}
        >
          <Avatar
            style={{
              height: 90,
              width: 90,
              objectFit: "cover",
              borderRadius: "50%",
              marginBlockStart: "-60px",
              marginInlineEnd: "15px",
            }}
            isGradient={true}
            {...config}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingBlock: "10px",
          }}
        >
          <h3
            style={{
              color: "#fff",
              display: "flex",
              marginBlock: "7px",
              textTransform: "uppercase",
            }}
          >
            {Object.keys(user).length && user.username}
          </h3>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "10px",
              color: "#C597F8",
              width: "fit-content",
            }}
          >
            ID: {Object.keys(user).length && user.referral_code}
          </div>
        </div>
        <button
          style={{
            margin: "10px auto 20px auto",
            padding: "10px",
            borderRadius: "15px",
          }}
          onClick={() => navigate("/account-settings")}
        >
          Account Settings
        </button>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {[
            {
              name: "Miners",
              link: "/miners-owned",
              icon: (
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.82489 0C6.94958 0 6.13219 0.483654 5.64665 1.28885L0.277344 10.1933C-0.0513621 10.7384 -0.0906756 11.4365 0.174332 12.0225C3.11255 18.5194 7.19583 24.3013 12.1842 29.0285L14.8032 31.5105C15.4918 32.1632 16.5082 32.1632 17.1968 31.5105L19.8159 29.0285C24.8041 24.3013 28.8875 18.5194 31.8257 12.0225C32.0906 11.4365 32.0514 10.7384 31.7226 10.1933L26.3533 1.28885C25.8678 0.483654 25.0504 0 24.1751 0H7.82489ZM7.51372 2.66498C7.58307 2.54997 7.69984 2.48087 7.82489 2.48087H11.3251L8.46021 10.0827C8.39422 10.2578 8.3444 10.4384 8.31083 10.6218C7.25794 10.5352 6.20594 10.4307 5.1552 10.3084L3.05232 10.0637L7.51372 2.66498ZM2.95327 12.5468C5.63612 17.9881 9.17877 22.8594 13.4168 26.9277L8.74127 13.1432C7.46621 13.0462 6.19234 12.9237 4.9203 12.7757L2.95327 12.5468ZM11.1902 13.2978L16 27.4781L20.8098 13.2978C17.6049 13.4589 14.3951 13.4589 11.1902 13.2978ZM23.2588 13.1432L18.5832 26.9277C22.8212 22.8594 26.3638 17.9881 29.0467 12.5468L27.0796 12.7757C25.8076 12.9237 24.5338 13.0462 23.2588 13.1432ZM28.9476 10.0637L26.8448 10.3084C25.794 10.4307 24.7421 10.5352 23.6892 10.6218C23.6555 10.4384 23.6057 10.2578 23.5398 10.0827L20.6749 2.48087H24.1751C24.3001 2.48087 24.417 2.54997 24.4862 2.665L28.9476 10.0637ZM21.373 10.7836C17.7934 10.9891 14.2067 10.9891 10.627 10.7836L13.7561 2.48087H18.2439L21.373 10.7836Z"
                    fill="white"
                  />
                </svg>
              ),
            },
            {
              name: "Balance",
              link: "/balance",
              icon: (
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20Z"
                    fill="white"
                  />
                  <path
                    d="M13.3001 11H10.7001C10.2001 11 9.80005 10.6 9.80005 10.1C9.80005 9.60005 10.2001 9.20005 10.7001 9.20005H14.4001C15.0001 9.20005 15.4001 8.80005 15.4001 8.20005C15.4001 7.60005 15.0001 7.20005 14.4001 7.20005H13.0001V6.30005C13.0001 5.70005 12.6001 5.30005 12.0001 5.30005C11.4001 5.30005 11.0001 5.70005 11.0001 6.30005V7.20005H10.7001C9.10005 7.20005 7.80005 8.50005 7.80005 10.1C7.80005 11.7 9.10005 13 10.7001 13H13.2001C13.7001 13 14.1001 13.4 14.1001 13.9C14.1001 14.4 13.7001 14.8 13.2001 14.8H9.50005C8.90005 14.8 8.50005 15.2 8.50005 15.8C8.50005 16.4 8.90005 16.8 9.50005 16.8H11.0001V17.7C11.0001 18.3 11.4001 18.7 12.0001 18.7C12.6001 18.7 13.0001 18.3 13.0001 17.7V16.8H13.3001C14.9001 16.8 16.2001 15.5 16.2001 13.9C16.2001 12.3 14.9001 11 13.3001 11Z"
                    fill="white"
                  />
                </svg>
              ),
            },
            {
              name: "Invite",
              link: "/invite",
              icon: (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.56737 20.944C5.2223 20.9343 4.8827 20.8554 4.56873 20.7119C4.25475 20.5684 3.97281 20.3633 3.73963 20.1088C3.50644 19.8542 3.32678 19.5554 3.2113 19.2301C3.09581 18.9048 3.04687 18.5596 3.06737 18.215C3.05537 16.062 3.06737 13.908 3.06737 11.755C3.06737 11.6224 3.12005 11.4952 3.21381 11.4014C3.30758 11.3077 3.43476 11.255 3.56737 11.255C3.69998 11.255 3.82715 11.3077 3.92092 11.4014C4.01469 11.4952 4.06737 11.6224 4.06737 11.755C4.06737 13.955 4.03537 16.155 4.06737 18.355C4.08337 19.462 4.91537 19.944 5.90537 19.944H18.3694C18.6841 19.9516 18.9936 19.8628 19.2565 19.6897C19.5194 19.5165 19.7231 19.2671 19.8404 18.975C19.9345 18.6297 19.9667 18.2705 19.9354 17.914V11.755C19.9354 11.6224 19.988 11.4952 20.0818 11.4014C20.1756 11.3077 20.3028 11.255 20.4354 11.255C20.568 11.255 20.6952 11.3077 20.7889 11.4014C20.8827 11.4952 20.9354 11.6224 20.9354 11.755C20.9354 13.98 21.0204 16.22 20.9354 18.443C20.9269 18.7833 20.8508 19.1185 20.7115 19.4292C20.5722 19.7398 20.3725 20.0196 20.124 20.2522C19.8755 20.4849 19.5832 20.6658 19.2641 20.7844C18.945 20.903 18.6055 20.9569 18.2654 20.943L5.56737 20.944Z"
                    fill="white"
                  />
                  <path
                    d="M11.6458 15.794C11.7282 15.8784 11.8399 15.9278 11.9578 15.932C11.9716 15.935 11.9856 15.937 11.9998 15.938C12.0135 15.937 12.0272 15.935 12.0408 15.932C12.1591 15.9285 12.2713 15.879 12.3538 15.794L16.0218 12.125C16.1128 12.0307 16.1632 11.9044 16.1621 11.7733C16.161 11.6422 16.1084 11.5168 16.0157 11.4241C15.923 11.3314 15.7976 11.2788 15.6665 11.2777C15.5354 11.2765 15.4091 11.3269 15.3148 11.418L12.4998 14.234L12.4998 3.492C12.4998 3.35939 12.4471 3.23221 12.3533 3.13845C12.2595 3.04468 12.1324 2.992 11.9998 2.992C11.8671 2.992 11.74 3.04468 11.6462 3.13845C11.5524 3.23221 11.4998 3.35939 11.4998 3.492V14.234L8.68475 11.418C8.59045 11.3269 8.46415 11.2765 8.33305 11.2777C8.20196 11.2788 8.07655 11.3314 7.98385 11.4241C7.89114 11.5168 7.83856 11.6422 7.83742 11.7733C7.83628 11.9044 7.88668 12.0307 7.97776 12.125L11.6458 15.794Z"
                    fill="white"
                  />
                </svg>
              ),
            },
          ].map((data, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                border: "1px solid #7B36EE",
                padding: "10px",
                width: "80px",
              }}
              onClick={() => navigate(`${data.link}`)}
            >
              <h3
                style={{
                  lineHeight: 0,
                  color: "#fff",
                }}
              >
                {data.name}
              </h3>
              {data.icon}
            </div>
          ))}
        </div>
      </ProfileCard>
      <ProfileLinkContainer>
        {PROFILE_LINKS.map((link, i) => (
          <Fragment key={i}>
            {link.name === "Log Out" ? (
              <ProfileList
                onClick={() =>
                  dispatch(logoutUser({}))
                    .unwrap()
                    .then((res) => navigate("/login"))
                }
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "tomato",
                  }}
                >
                  <span style={{ marginInlineEnd: "20px" }}>{link.icon}</span>{" "}
                  {link.name}
                </div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.96967 7.46967C10.2626 7.17678 10.7374 7.17678 11.0303 7.46967L15.0303 11.4697C15.3232 11.7626 15.3232 12.2374 15.0303 12.5303L11.0303 16.5303C10.7374 16.8232 10.2626 16.8232 9.96967 16.5303C9.67678 16.2374 9.67678 15.7626 9.96967 15.4697L13.4393 12L9.96967 8.53033C9.67678 8.23744 9.67678 7.76256 9.96967 7.46967Z"
                    fill="white"
                  />
                </svg>
              </ProfileList>
            ) : link.name === "FAQ" ? (
              <ProfileList
                onClick={() =>
                  (window.location.href = "https://pubmining.org/#faq")
                }
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <span style={{ marginInlineEnd: "20px" }}>{link.icon}</span>{" "}
                  {link.name}
                </div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.96967 7.46967C10.2626 7.17678 10.7374 7.17678 11.0303 7.46967L15.0303 11.4697C15.3232 11.7626 15.3232 12.2374 15.0303 12.5303L11.0303 16.5303C10.7374 16.8232 10.2626 16.8232 9.96967 16.5303C9.67678 16.2374 9.67678 15.7626 9.96967 15.4697L13.4393 12L9.96967 8.53033C9.67678 8.23744 9.67678 7.76256 9.96967 7.46967Z"
                    fill="white"
                  />
                </svg>
              </ProfileList>
            ) : (
              <ProfileLink to={link.link}>
                <ProfileList>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#fff",
                    }}
                  >
                    <span style={{ marginInlineEnd: "20px" }}>{link.icon}</span>{" "}
                    {link.name}
                  </div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.96967 7.46967C10.2626 7.17678 10.7374 7.17678 11.0303 7.46967L15.0303 11.4697C15.3232 11.7626 15.3232 12.2374 15.0303 12.5303L11.0303 16.5303C10.7374 16.8232 10.2626 16.8232 9.96967 16.5303C9.67678 16.2374 9.67678 15.7626 9.96967 15.4697L13.4393 12L9.96967 8.53033C9.67678 8.23744 9.67678 7.76256 9.96967 7.46967Z"
                      fill="white"
                    />
                  </svg>
                </ProfileList>
              </ProfileLink>
            )}
          </Fragment>
        ))}
      </ProfileLinkContainer>
    </ProfileContainer>
  );
};

export default Profile;
